// Utility to render template with {{variable}} placeholders
export function renderTemplate(templateBody, data) {
  return templateBody.replace(/{{\s*(\w+)\s*}}/g, (_, key) => {
    // Special handling for photo_url to generate img tag
    if (key === 'photo_url' && data[key]) {
      return `<img src="${data[key]}" alt="Resident Photo" style="width: 128px; height: 160px; object-fit: cover; border: 2px solid #ccc;" />`;
    }
    return data[key] || '';
  });
}
